/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ date: NonNullable<unknown> }} Profile_Login_Last_UsedInputs */



/**
* | output |
* | --- |
* | "last used {date}" |
*
* @param {Profile_Login_Last_UsedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const profile_login_last_used = /** @type {((inputs: Profile_Login_Last_UsedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Login_Last_UsedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`dernière utilisation le ${i?.date}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`último uso el ${i?.date}`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`último uso em ${i?.date}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`ultimo utilizzo il ${i?.date}`)
	return /** @type {LocalizedString} */ (`last used ${i?.date}`)
});